module.exports = __webpack_public_path__ + "media/images/icons/building2x-67fc60bdc34dfd2200b28eedc9807fa3.png";